export const menuDesignToken = {
	background: '{primary.950}',
	border: {
		radius: '0',
		color: '{primary.900}',
	},
	item: {
		color: 'white',
		focus: {
			color: 'white',
			background: '{primary.700}',
		},
	},
	separator: {
		border: {
			color: '{primary.850}',
		},
	},
};
